export const GET_DESTINATIONS_FOR_ROOT_ENDPOINT = '/graphql/execute.json/yme/getDestinationsForRoot;rootPath=';
export var CardsPerPage;
(function (CardsPerPage) {
    CardsPerPage[CardsPerPage["DESKTOP"] = 12] = "DESKTOP";
    CardsPerPage[CardsPerPage["MOBILE"] = 8] = "MOBILE";
})(CardsPerPage || (CardsPerPage = {}));
export var FilterName;
(function (FilterName) {
    FilterName["TYPE_LABEL"] = "typeLabel";
    FilterName["PARTNER_NAME"] = "partnerName";
    FilterName["VEHICLE_RENTAL"] = "vehicleRental";
    FilterName["LOCATION"] = "location";
    FilterName["UNITS"] = "units";
    FilterName["DATE_RANGES"] = "dateRanges";
})(FilterName || (FilterName = {}));
export const MAP_LABEL_TO_FILTER_NAME = {
    location: 'country',
    typeLabel: 'category',
    partnerName: 'partner',
};
